import AbstractEntity from "../AbstractEntity";

export default class Quotation extends AbstractEntity {
    _id;
    _vat;
    _createdAt;
    _quotationItemsId;
    _interventionId;


    getId() {
        return this._id;
    }

    getVat() {
        return this._vat;
    }

    getCreatedAt() {
        return this._createdAt;
    }

    getQuotationItemsId() {
        return this._quotationItemsId;
    }

    getInterventionId() {
        return this._interventionId;
    }

    getClassName() {
        return "quotation";
    }
}